import { render, staticRenderFns } from "./CostOvertimeDetail.vue?vue&type=template&id=1a5bcfb6&scoped=true&"
import script from "./CostOvertimeDetail.vue?vue&type=script&lang=js&"
export * from "./CostOvertimeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5bcfb6",
  null
  
)

export default component.exports